"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompetitionEntry = instanceOfCompetitionEntry;
exports.CompetitionEntryFromJSON = CompetitionEntryFromJSON;
exports.CompetitionEntryFromJSONTyped = CompetitionEntryFromJSONTyped;
exports.CompetitionEntryToJSON = CompetitionEntryToJSON;
exports.CompetitionEntryToJSONTyped = CompetitionEntryToJSONTyped;
var Competition_1 = require("./Competition");
var Ace_1 = require("./Ace");
var CompetitionEntrySection_1 = require("./CompetitionEntrySection");
var CompetitionParticipant_1 = require("./CompetitionParticipant");
var BracketAssignment_1 = require("./BracketAssignment");
var JoinRestriction_1 = require("./JoinRestriction");
var CompetitionEntryInbox_1 = require("./CompetitionEntryInbox");
var EntryMemberRequest_1 = require("./EntryMemberRequest");
var CompetitionEntrantMeta_1 = require("./CompetitionEntrantMeta");
var CompetitionCheckIn_1 = require("./CompetitionCheckIn");
var CompetitionInvite_1 = require("./CompetitionInvite");
var CompetitionEntryNote_1 = require("./CompetitionEntryNote");
/**
 * Check if a given object implements the CompetitionEntry interface.
 */
function instanceOfCompetitionEntry(value) {
    if (!('competition' in value) || value['competition'] === undefined)
        return false;
    return true;
}
function CompetitionEntryFromJSON(json) {
    return CompetitionEntryFromJSONTyped(json, false);
}
function CompetitionEntryFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateModified': json['dateModified'] == null ? undefined : (new Date(json['dateModified'])),
        'owner': json['owner'] == null ? undefined : json['owner'],
        'aces': json['aces'] == null ? undefined : (json['aces'].map(Ace_1.AceFromJSON)),
        'acesInheriting': json['acesInheriting'] == null ? undefined : json['acesInheriting'],
        'competition': (0, Competition_1.CompetitionFromJSON)(json['competition']),
        'alternateName': json['alternateName'] == null ? undefined : json['alternateName'],
        'representing': json['representing'] == null ? undefined : json['representing'],
        'leader': json['leader'] == null ? undefined : (0, CompetitionParticipant_1.CompetitionParticipantFromJSON)(json['leader']),
        'joinRestriction': json['joinRestriction'] == null ? undefined : (0, JoinRestriction_1.JoinRestrictionFromJSON)(json['joinRestriction']),
        'description': json['description'] == null ? undefined : json['description'],
        'abbreviation': json['abbreviation'] == null ? undefined : json['abbreviation'],
        'image': json['image'] == null ? undefined : json['image'],
        'imageIsCustom': json['imageIsCustom'] == null ? undefined : json['imageIsCustom'],
        'members': json['members'] == null ? undefined : (json['members'].map(CompetitionParticipant_1.CompetitionParticipantFromJSON)),
        'requests': json['requests'] == null ? undefined : (json['requests'].map(EntryMemberRequest_1.EntryMemberRequestFromJSON)),
        'playingFor': json['playingFor'] == null ? undefined : json['playingFor'],
        'dropped': json['dropped'] == null ? undefined : json['dropped'],
        'rank': json['rank'] == null ? undefined : json['rank'],
        'seed': json['seed'] == null ? undefined : json['seed'],
        'lookingForMore': json['lookingForMore'] == null ? undefined : json['lookingForMore'],
        'initialRating': json['initialRating'] == null ? undefined : json['initialRating'],
        'note': json['note'] == null ? undefined : (0, CompetitionEntryNote_1.CompetitionEntryNoteFromJSON)(json['note']),
        'assignments': json['assignments'] == null ? undefined : (json['assignments'].map(BracketAssignment_1.BracketAssignmentFromJSON)),
        'checkIns': json['checkIns'] == null ? undefined : (json['checkIns'].map(CompetitionCheckIn_1.CompetitionCheckInFromJSON)),
        'invites': json['invites'] == null ? undefined : (json['invites'].map(CompetitionInvite_1.CompetitionInviteFromJSON)),
        'section': json['section'] == null ? undefined : (0, CompetitionEntrySection_1.CompetitionEntrySectionFromJSON)(json['section']),
        'metas': json['metas'] == null ? undefined : (json['metas'].map(CompetitionEntrantMeta_1.CompetitionEntrantMetaFromJSON)),
        'inboxes': json['inboxes'] == null ? undefined : (json['inboxes'].map(CompetitionEntryInbox_1.CompetitionEntryInboxFromJSON)),
        'illegal': json['illegal'] == null ? undefined : json['illegal'],
    };
}
function CompetitionEntryToJSON(json) {
    return CompetitionEntryToJSONTyped(json, false);
}
function CompetitionEntryToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'version': value['version'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateModified': value['dateModified'] == null ? undefined : ((value['dateModified']).toISOString()),
        'owner': value['owner'],
        'aces': value['aces'] == null ? undefined : (value['aces'].map(Ace_1.AceToJSON)),
        'acesInheriting': value['acesInheriting'],
        'competition': (0, Competition_1.CompetitionToJSON)(value['competition']),
        'alternateName': value['alternateName'],
        'representing': value['representing'],
        'leader': (0, CompetitionParticipant_1.CompetitionParticipantToJSON)(value['leader']),
        'joinRestriction': (0, JoinRestriction_1.JoinRestrictionToJSON)(value['joinRestriction']),
        'description': value['description'],
        'abbreviation': value['abbreviation'],
        'image': value['image'],
        'imageIsCustom': value['imageIsCustom'],
        'members': value['members'] == null ? undefined : (value['members'].map(CompetitionParticipant_1.CompetitionParticipantToJSON)),
        'requests': value['requests'] == null ? undefined : (value['requests'].map(EntryMemberRequest_1.EntryMemberRequestToJSON)),
        'playingFor': value['playingFor'],
        'dropped': value['dropped'],
        'rank': value['rank'],
        'seed': value['seed'],
        'lookingForMore': value['lookingForMore'],
        'initialRating': value['initialRating'],
        'note': (0, CompetitionEntryNote_1.CompetitionEntryNoteToJSON)(value['note']),
        'assignments': value['assignments'] == null ? undefined : (value['assignments'].map(BracketAssignment_1.BracketAssignmentToJSON)),
        'checkIns': value['checkIns'] == null ? undefined : (value['checkIns'].map(CompetitionCheckIn_1.CompetitionCheckInToJSON)),
        'invites': value['invites'] == null ? undefined : (value['invites'].map(CompetitionInvite_1.CompetitionInviteToJSON)),
        'section': (0, CompetitionEntrySection_1.CompetitionEntrySectionToJSON)(value['section']),
        'metas': value['metas'] == null ? undefined : (value['metas'].map(CompetitionEntrantMeta_1.CompetitionEntrantMetaToJSON)),
        'inboxes': value['inboxes'] == null ? undefined : (value['inboxes'].map(CompetitionEntryInbox_1.CompetitionEntryInboxToJSON)),
        'illegal': value['illegal'],
    };
}
